import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock, Instagram, Facebook, Music2 } from "lucide-react";
import Logo from "@/components/Logo";
import { useContent } from "@/context/ContentProvider";

const Footer = () => {
  const { t } = useContent();
  const links = t("footer.links", []);
  const hours = (t("contact.hours", "") || "").split("\n").filter(Boolean);
  const socials = [
    { url: t("social.instagram", ""), icon: Instagram, label: "Instagram" },
    { url: t("social.facebook", ""), icon: Facebook, label: "Facebook" },
    { url: t("social.tiktok", ""), icon: Music2, label: "TikTok" },
  ].filter((s) => s.url);

  return (
    <footer className="grain relative overflow-hidden bg-[#4b3a2f] text-[#f2e9dd]">
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <Logo className="h-14 w-14 ring-1 ring-[#c9a24b]/50" />
              <div>
                <p className="font-serif-d text-2xl font-semibold tracking-[0.22em]">{t("site.name", "AWEN")}</p>
                <p className="font-mono-d text-[10px] uppercase tracking-[0.22em] text-[#cdb79e]">
                  {t("site.tagline", "Bienestar emocional integral")}
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#cdb79e]">
              {t("footer.about_text", "")}
            </p>
            {socials.length > 0 && (
              <div className="mt-6 flex gap-3">
                {socials.map((s) => (
                  <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.label} data-testid={`footer-social-${s.label.toLowerCase()}`} className="flex h-10 w-10 items-center justify-center rounded-full border border-[#c9a24b]/40 text-[#f2e9dd] transition-colors hover:bg-[#c9a24b] hover:text-[#4b3a2f]">
                    <s.icon size={16} />
                  </a>
                ))}
              </div>
            )}
          </div>
          <div>
            <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[#c9a24b]">{t("footer.explore_title", "Explora")}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {(links.length ? links : [{ label: "Catálogo completo", link: "/catalogo" }]).map((l, i) => (
                <li key={i}><Link to={l.link} className="gold-underline" data-testid={`footer-link-${i}`}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[#c9a24b]">{t("footer.note_title", "Tu bienestar, nuestra prioridad")}</p>
            <p className="mt-5 text-sm leading-relaxed text-[#cdb79e]">{t("footer.note", "")}</p>
            <div className="mt-6 space-y-2 text-sm text-[#cdb79e]">
              {t("contact.email", "") && <p className="flex items-center gap-2"><Mail size={14} className="text-[#c9a24b]" /> {t("contact.email")}</p>}
              {t("contact.whatsapp", "") && <p className="flex items-center gap-2"><Phone size={14} className="text-[#c9a24b]" /> {t("contact.whatsapp")}</p>}
              {t("contact.address", "") && <p className="flex items-center gap-2"><MapPin size={14} className="text-[#c9a24b]" /> {t("contact.address")}</p>}
              {hours.length > 0 && (
                <p className="flex items-start gap-2"><Clock size={14} className="mt-0.5 text-[#c9a24b]" /><span>{hours.map((h, i) => <span key={i} className="block">{h}</span>)}</span></p>
              )}
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-[#c9a24b]/20 pt-8 text-xs text-[#cdb79e]/70 sm:flex-row">
          <p>© {new Date().getFullYear()} {t("footer.copyright", "AWEN — Bienestar emocional integral")}</p>
          <p className="font-mono-d tracking-widest">AWEN · TU BIENESTAR, NUESTRA PRIORIDAD</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
